import React, { useState, useEffect } from 'react';
import SelectOrders from './SelectOrders';

const OrderManager = ({ 
  selectedOrders = [], 
  onOrdersChange, 
  accountNumber
}) => {
  const [showOrderDialog, setShowOrderDialog] = useState(false);
  const [internalSelectedOrders, setInternalSelectedOrders] = useState(selectedOrders);

  // Sync internal state with props
  useEffect(() => {
    setInternalSelectedOrders(selectedOrders);
  }, [selectedOrders]);

  const handleAddOrders = () => {
    setShowOrderDialog(true);
  };

  const handleRemoveOrder = (orderNumber) => {
    const updatedOrders = internalSelectedOrders.filter(order => order !== orderNumber);
    setInternalSelectedOrders(updatedOrders);
    onOrdersChange(updatedOrders);
  };

  const handleClearAll = () => {
    setInternalSelectedOrders([]);
    onOrdersChange([]);
  };

  const handleOrderSelection = (newOrderNumbers) => {
    // Combine existing orders with new ones, avoiding duplicates
    const combinedOrders = [...new Set([...internalSelectedOrders, ...newOrderNumbers])];
    setInternalSelectedOrders(combinedOrders);
    onOrdersChange(combinedOrders);
    setShowOrderDialog(false);
  };

  const handleCloseOrderDialog = () => {
    setShowOrderDialog(false);
  };

  return (
    <div className="order-manager">
      <div className="level is-mobile mb-4">
        <div className="level-left">
          <div className="level-item">
            <h6 className="title is-6 has-text-primary">
              <span className="icon-text">
                <span className="icon">
                  <i className="fas fa-list-ul"></i>
                </span>
                <span>Selected Orders ({internalSelectedOrders.length})</span>
              </span>
            </h6>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <div className="buttons">
              {internalSelectedOrders.length > 0 && (
                <button
                  className="button is-small is-danger is-outlined"
                  onClick={handleClearAll}
                  title="Clear all orders"
                >
                  <span className="icon is-small">
                    <i className="fas fa-trash"></i>
                  </span>
                  <span>Clear All</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {internalSelectedOrders.length > 0 ? (
        <div className="box" style={{ padding: '1rem' }}>
          <div className="field is-grouped is-grouped-multiline">
            {internalSelectedOrders.map((orderNumber) => (
              <div key={orderNumber} className="control">
                <div className="tags has-addons">
                  <span className="tag is-info is-light">
                    <span className="icon is-small">
                      <i className="fas fa-receipt"></i>
                    </span>
                    <span>{orderNumber}</span>
                  </span>
                  <button
                    className="tag is-delete"
                    onClick={() => handleRemoveOrder(orderNumber)}
                    title={`Remove order ${orderNumber}`}
                  ></button>
                </div>
              </div>
            ))}
            
            {/* Add Orders Button */}
            <div className="control">
              <button
                className="button is-small is-primary is-outlined"
                onClick={handleAddOrders}
                title="Add more orders"
              >
                <span className="icon is-small">
                  <i className="fas fa-plus"></i>
                </span>
                <span>Add Orders</span>
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="box has-text-centered" style={{ padding: '2rem' }}>
          <div className="icon-text mb-3">
            <span className="icon is-large has-text-grey-light">
              <i className="fas fa-clipboard-list fa-2x"></i>
            </span>
          </div>
          <p className="has-text-grey">No orders selected</p>
          <p className="has-text-grey is-size-7 mb-4">
            Click "Add Orders" to start selecting orders for comparison.
          </p>
          <button
            className="button is-primary is-outlined"
            onClick={handleAddOrders}
          >
            <span className="icon">
              <i className="fas fa-plus"></i>
            </span>
            <span>Add Orders</span>
          </button>
        </div>
      )}

      {/* Select Orders Dialog */}
      <SelectOrders
        open={showOrderDialog}
        onClose={handleCloseOrderDialog}
        onDone={handleOrderSelection}
        accountNumber={accountNumber}
        title="Select Orders for Water Profile Comparison"
        maxSelection={10}
      />
    </div>
  );
};

export default OrderManager;